import React, { useEffect, useState } from "react";
import Styles from "./UploadFiles.module.css";
import { Modal } from "@mui/material";
import { Check, Close } from "@mui/icons-material";

import { getDocumentUrlByLedgerId } from "../../../../Services/ApiCalling/banking";
import {
  approveDocuments,
  rejectAgreement,
  submitDocuments,
  uploadFaFile,
  uploadLoaFile,
  uploadLoiFile,
  uploadOtherFile,
} from "../../../../Services/BuySell/Listing";

import {
  fetchActiveConnection,
  fetchActiveLedger,
  fetchMainScreenActiveConnection,
  fetchViewDocumentHistory,
} from "../../../../Redux/Slices/CapacitySlice";
import {
  generateFinalDocument,
  generateLoaDocument,
  generateLoiDocument,
} from "../../../../Services/ApiCalling/Listing";
import { toast } from "react-toastify";
import { ReactComponent as ViewIcon } from "../../../../assets/images/view.svg";
import { ReactComponent as UploadIcon } from "../../../../assets/images/uploadIcon.svg";
import { ReactComponent as ViewUploadFile } from "../../../../assets/images/viewUploadFile.svg";
import { ReactComponent as CrossIcon } from "../../../../assets/images/circlex.svg";
import { useDispatch, useSelector } from "react-redux";
import PreviewModal from "../../../../commons/PreviewModal/PreviewModal";
import { useLocation } from "react-router-dom";
import { formatDate } from "../../../../helpers/dateFormat";
import Ongoing from "../Ongoing/Ongoing";
import { toastProperties } from "../../../../commons/Toast/Toaster";
import ConfirmationModal from "../../../../commons/ConfirmationModal/ConfirmationModal";

// Constants

const UploadDocModal = ({
  open,
  handleClose,
  connectionId,
  onAllDocsUploaded,
  agreementStatus,
  activeCounterparty,
  data,
  capacityId,
  type,
  viewType,
  useSecondaryAccent = false,
}) => {
  // Redux and router hooks
  const dispatch = useDispatch();
  const location = useLocation();
  const id = useSelector((state) => state.CapacitySlice?.activeMain?.id);
  const { documentViewHistory, loading, error } = useSelector(
    (state) => state.CapacitySlice,
  );
  const [conformOpen, setConformOpen] = useState(false);
  const [conformReject, setConformReject] = useState(false);
  const listingId = capacityId || location?.search?.split("=")[1] || id;
  const isForwardRFP =
    (location?.pathname === "/tradeconnect" &&
      ["initiate", "place_bid"].includes(
        new URLSearchParams(location?.search).get("type"),
      )) ||
    sessionStorage.getItem("lastProductRoute") === "/tradeconnect";
  const mainScreenData = useSelector(
    (state) => state.CapacitySlice?.mainScreenActiveConnection,
  );

  const activeConnection = React.useMemo(() => {
    if (!connectionId || !mainScreenData) return null;

    if (Array.isArray(mainScreenData)) {
      return (
        mainScreenData.find(
          (item) => Number(item?.id) === Number(connectionId),
        ) || null
      );
    }

    if (
      typeof mainScreenData === "object" &&
      Number(mainScreenData?.id) === Number(connectionId)
    ) {
      return mainScreenData;
    }

    return null;
  }, [mainScreenData, connectionId]);

  // State management
  const [comments, setComments] = useState("");
  const [submitConfirmOpen, setSubmitConfirmOpen] = useState(false);

  // File states - now storing File objects instead of just filenames
  const [selectedFiles, setSelectedFiles] = useState({
    loi: null,
    loa: null,
    fa: null,
    other: null,
  });

  const [uploadedDocumentIds, setUploadedDocumentIds] = useState({
    loi: null,
    loa: null,
    fa: null,
    other: null,
  });

  // Loading and modal states
  const [approvalLoading, setApprovalLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [previewModal, setPreviewModal] = useState(false);
  const [ongoing, setOngoing] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState(null);
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole,
  ).toLowerCase();

  // New: upload confirmation state
  const [uploadConfirmOpen, setUploadConfirmOpen] = useState(false);
  const [pendingUploadData, setPendingUploadData] = useState(null);
  const [hasNewLoiOrLoaUpload, setHasNewLoiOrLoaUpload] = useState(false);

  // Computed values
  const showApprovalButtons = agreementStatus;

  const shouldEnableUploads = !agreementStatus && type !== "view";

  const isFirstParty = !agreementStatus;
  const finalAgreementUploadedOrEditing =
    isFirstParty &&
    (selectedFiles.fa ||
      activeCounterparty?.agreementDocumentHistory?.length > 0);

  const shouldDisableUploads = showApprovalButtons;

  // Document state checks - Updated to not disable other fields when FA is uploaded
  const documentStates = {
    isLoiDisabled:
      shouldDisableUploads ||
      (agreementStatus && !shouldEnableUploads) ||
      type === "view",

    isLoaDisabled:
      shouldDisableUploads ||
      (agreementStatus && !shouldEnableUploads) ||
      type === "view",

    isOtherDocumentsDisabled:
      shouldDisableUploads ||
      (agreementStatus && !shouldEnableUploads) ||
      type === "view",

    isFinalAgreementDisabled:
      shouldDisableUploads ||
      (agreementStatus && !shouldEnableUploads) ||
      (agreementStatus && finalAgreementUploadedOrEditing) ||
      type === "view",
  };

  const updateSelectedFile = (type, file) => {
    setSelectedFiles((prev) => ({ ...prev, [type]: file }));
  };

  const updateUploadedDocId = (type, id) => {
    setUploadedDocumentIds((prev) => ({ ...prev, [type]: id }));
  };

  const resetFileSelection = (type) => {
    updateSelectedFile(type, null);
    updateUploadedDocId(type, null);
    if (type === "other") {
      setComments("");
    }
  };

  // cancel upload confirmation (clears selected file)
  const handleCancelUpload = () => {
    if (pendingUploadData?.type) {
      resetFileSelection(pendingUploadData.type);
    }
    setPendingUploadData(null);
    setUploadConfirmOpen(false);
  };

  // Perform upload after confirmation
  const performUpload = async () => {
    if (!pendingUploadData) return;
    const { type, displayName } = pendingUploadData;

    // Validation before upload
    if (!connectionId) {
      toast.error("Connection ID is missing.");
      handleCancelUpload();
      return;
    }

    // For Other docs, ensure file/comments exist
    if (type === "other") {
      if (!selectedFiles.other) {
        toast.error("Please select a document to upload!");
        handleCancelUpload();
        return;
      }
      // if (!comments.trim()) {
      //   toast.error("Please enter comments for the other document.");
      //   handleCancelUpload();
      //   return;
      // }
    }

    setUploading(true);

    try {
      if (type === "other") {
        const formData = new FormData();
        formData.append("file", selectedFiles.other);
        await uploadOtherFile(
          formData,
          connectionId,
          listingId,
          comments.trim(),
        );
        dispatch(fetchViewDocumentHistory(connectionId));
        toast.success("Other document uploaded successfully!");
        resetFileSelection("other");
      } else {
        const file = selectedFiles[type];
        await uploadHandlers[type](file);
        dispatch(fetchViewDocumentHistory(connectionId));
        toast.success(`${displayName} uploaded successfully!`);

        // Track uploads for LOI, LOA, and FA
        if (type === "loi" || type === "loa" || type === "fa") {
          setHasNewLoiOrLoaUpload(true);
        }

        resetFileSelection(type);

        if (type === "fa") {
          if (
            (role === "generator" &&
              activeConnection?.conAgreementAcceptanceStatus) ||
            (role === "consumer" &&
              activeConnection?.genAgreementAcceptanceStatus)
          ) {
            return;
          }
          dispatch(fetchViewDocumentHistory(connectionId));
          dispatch(fetchActiveLedger({ capId: listingId }));
          dispatch(fetchActiveConnection({ curr: 0, capId: listingId }));
          dispatch(fetchMainScreenActiveConnection({ capId: listingId }));
          handleClose();
        }
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          `Failed to upload ${displayName || "document"}. Please try again.`,
      );
    } finally {
      setUploading(false);
      setPendingUploadData(null);
      setUploadConfirmOpen(false);
    }
  };

  // Document generation handlers
  const documentGenerators = {
    loi: async () => {
      if (!connectionId) return;
      try {
        const response = await generateLoiDocument(connectionId, isForwardRFP);
        if (!response || response.status !== 200 || !response.data) {
          return;
        }
        const blob = response.data;
        const url = window.URL.createObjectURL(
          new Blob([blob], {
            type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX MIME type
          }),
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Letter_of_Intent.docx"); // Change extension to .docx
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        toast.success("LOI DOCX generated and downloaded successfully!");
      } catch (error) {
      }
    },

    loa: async () => {
      if (!connectionId) return;
      try {
        const response = await generateLoaDocument(connectionId, isForwardRFP);
        if (!response || response.status !== 200 || !response.data) {
          return;
        }
        const blob = response.data;
        const url = window.URL.createObjectURL(
          new Blob([blob], {
            type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX MIME type
          }),
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Letter_of_Award.docx"); // Change extension to .docx
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        toast.success("LOA DOCX generated and downloaded successfully!");
      } catch (error) {
      }
    },

    fa: async () => {
      if (!connectionId) return;
      try {
        const response = await generateFinalDocument(
          connectionId,
          isForwardRFP,
        );
        if (!response || response.status !== 200 || !response.data) {
          return;
        }
        const blob = response.data;
        const url = window.URL.createObjectURL(
          new Blob([blob], {
            type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          }),
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Final_Agreement.docx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        toast.success(
          "Final Agreement DOCX generated and downloaded successfully!",
        );
      } catch (error) {
      }
    },
  };

  // File upload handlers
  const uploadHandlers = {
    loi: async (file) => {
      if (file.type !== "application/pdf") {
        toast.error("Only PDF files are allowed!");
        return;
      }
      const formData = new FormData();
      formData.append("file", file);
      const response = await uploadLoiFile(formData, connectionId, listingId);
      if (response?.data?.id) updateUploadedDocId("loi", response.data.id);
      // toast.success("LOI file uploaded successfully!");
      return response;
    },

    loa: async (file) => {
      if (file.type !== "application/pdf") {
        toast.error("Only PDF files are allowed!");
        return;
      }
      const formData = new FormData();
      formData.append("file", file);
      const response = await uploadLoaFile(formData, connectionId, listingId);
      if (response?.data?.id) updateUploadedDocId("loa", response.data.id);
      // toast.success("LOA file uploaded successfully!");
      return response;
    },

    fa: async (file) => {
      if (file.type !== "application/pdf") {
        toast.error("Only PDF files are allowed!");
        return;
      }
      const formData = new FormData();
      formData.append("file", file);
      const response = await uploadFaFile(formData, connectionId, listingId);
      if (response?.data?.id) updateUploadedDocId("fa", response.data.id);
      // toast.success("Final Agreement uploaded successfully!");
      return response;
    },
  };

  // Modified handleFileChange: now asks for confirmation before uploading LOI/LOA/FA and auto for Other when ready
  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (file.type !== "application/pdf") {
      toast.error("Only PDF files are allowed!");
      e.target.value = null;
      return;
    }

    const inputName = e.target.name;
    const documentTypeMap = {
      fileUpload: { type: "loi", displayName: "Letter of Intent" },
      fileUploadLoa: { type: "loa", displayName: "Letter of Award" },
      fileUploadFa: { type: "fa", displayName: "Final Agreement" },
      fileUploadOther: { type: "other", displayName: "Other Documents" },
    };

    const docInfo = documentTypeMap[inputName];
    if (!docInfo) return;

    // Store the file object
    updateSelectedFile(docInfo.type, file);

    // For "Other Documents", wait for comments and auto-open confirmation via effect
    if (docInfo.type === "other") {
      setPendingUploadData({
        type: "other",
        displayName: "Other Documents",
      });
      setUploadConfirmOpen(true);
      e.target.value = null;
      return;
    }

    // For LOI, LOA, FA: ask for confirmation before upload
    setPendingUploadData({
      type: docInfo.type,
      displayName: docInfo.displayName,
    });
    setUploadConfirmOpen(true);
    e.target.value = null; // allow re-selecting the same file if needed
  };

  // Document view handlers
  const handleViewDoc = async (id) => {
    try {
      const response = await getDocumentUrlByLedgerId(id);
      const url = response.data;
      if (url) {
        setPreviewFileUrl(url);
        setPreviewModal(true);
      } else {
        toast.error("Document URL not found");
      }
    } catch (err) {
      toast.error("Could not fetch document URL.");
    }
  };

  const documentViewers = {
    loi: () => {
      if (uploadedDocumentIds.loi) {
        handleViewDoc(uploadedDocumentIds.loi);
      } else {
        const loiDocs = documentViewHistory
          ?.filter(
            (doc) =>
              doc.filename?.toLowerCase().includes("loi") ||
              doc.filename?.toLowerCase().includes("letter_of_intent") ||
              doc.documentType === "LOI",
          )
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        const loiDoc = loiDocs?.[0];
        if (loiDoc) {
          handleViewDoc(loiDoc.id);
        } else {
          toast.info("No LOI document has been uploaded yet.");
        }
      }
    },

    loa: () => {
      if (uploadedDocumentIds.loa) {
        handleViewDoc(uploadedDocumentIds.loa);
      } else {
        const loaDocs = documentViewHistory
          ?.filter(
            (doc) =>
              doc.filename?.toLowerCase().includes("loa") ||
              doc.filename?.toLowerCase().includes("letter_of_agreement") ||
              doc.documentType === "LOA",
          )
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        const loaDoc = loaDocs?.[0];
        if (loaDoc) {
          handleViewDoc(loaDoc.id);
        } else {
          toast.info("No LOA document has been uploaded yet.");
        }
      }
    },

    fa: () => {
      if (uploadedDocumentIds.fa) {
        handleViewDoc(uploadedDocumentIds.fa);
        return;
      }

      if (documentViewHistory && documentViewHistory.length > 0) {
        const faDocs = documentViewHistory
          ?.filter(
            (doc) =>
              doc.documentType === "FA" ||
              doc.filename?.toLowerCase().includes("final") ||
              doc.filename?.toLowerCase().includes("agreement") ||
              doc.filename?.toLowerCase().includes("fa") ||
              (selectedFiles.fa && doc.filename === selectedFiles.fa),
          )
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

        const faDoc = faDocs?.[0];
        if (faDoc) {
          handleViewDoc(faDoc.id);
        } else {
          if (selectedFiles.fa) {
            toast.error(
              "Could not find the uploaded Final Agreement document. Please try refreshing.",
            );
          } else {
            toast.info("No Final Agreement document has been uploaded yet.");
          }
        }
      } else {
        toast.info("No documents found in history.");
      }
    },

    other: () => {
      if (uploadedDocumentIds.other) {
        handleViewDoc(uploadedDocumentIds.other);
      } else {
        const otherDoc = documentViewHistory?.find(
          (doc) =>
            doc.documentType === "OTHER" ||
            (!doc.filename?.toLowerCase().includes("loi") &&
              !doc.filename?.toLowerCase().includes("loa") &&
              !doc.filename?.toLowerCase().includes("final_agreement")),
        );
        if (otherDoc) {
          handleViewDoc(otherDoc.id);
        } else {
          toast.info("No other document has been uploaded yet.");
        }
      }
    },
  };

  // Approval handlers
  async function Approve() {
    if (!hasCurrentLoiOrLoa) {
      toast.warn("Please upload at least one document before submitting.");
      return;
    }
    setApprovalLoading(true);
    try {
      const payload = {
        userType: role,
        consumerName: activeConnection?.capacityConsumer?.name,
        generatorName: activeConnection?.capacityGenerator?.name,
        id: activeConnection?.id,
      };
      const res = await approveDocuments(payload);
      if (res?.data?.code === 200) {
        // ✅ Await all dispatches before proceeding
        await Promise.all([
          dispatch(fetchViewDocumentHistory(connectionId)),
          dispatch(fetchActiveLedger({ capId: listingId })),
          dispatch(fetchActiveConnection({ curr: 0, capId: listingId })),
          dispatch(fetchMainScreenActiveConnection({ capId: listingId })),
        ]);

        setConformOpen(false);
        if (viewType !== "RA_TERMS" && viewType !== "RA_ACTIVE") {
          setOngoing(true);
        }
        handleClose();
      }
    } catch {
      toast.error("Could not approve documents.", toastProperties);
    } finally {
      setApprovalLoading(false);
    }
  }



  const handleRejectClick = async () => {
    if (!connectionId) {
      toast.error("Connection ID is missing.");
      return;
    }
    setApprovalLoading(true);
    try {
      const res = await rejectAgreement(connectionId);
      if (res?.data?.code === 200) {
        // if (location.pathname === "/dashboard") {

        dispatch(fetchActiveConnection({ curr: 0, capId: listingId }));
        dispatch(fetchMainScreenActiveConnection({ capId: listingId }));
      }
      handleClose();
      if (typeof onAllDocsUploaded === "function") {
        onAllDocsUploaded();
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to reject agreement.",
      );
    } finally {
      setApprovalLoading(false);
    }
  };

  // Comments handler
  const handleCommentsChange = (text) => {
    const words = text.trim().split(/\s+/);
    if (words.length <= 50) {
      setComments(text);
    } else {
      const limitedText = words.slice(0, 50).join(" ");
      setComments(limitedText);
    }
  };

  // Handle submission of Other documents (legacy button removed; kept for safety if invoked elsewhere)
  const handleSubmit = async () => {
    if (!selectedFiles.other) {
      toast.error("Please select a document to upload!");
      return;
    }

    if (!comments.trim()) {
      toast.error("Please enter comments for the other document.");
      return;
    }

    if (!connectionId) {
      toast.error("Connection ID is missing.");
      return;
    }

    setPendingUploadData({ type: "other", displayName: "Other Documents" });
    setUploadConfirmOpen(true);
  };

  const hasUploadedAnyDocument = React.useMemo(() => {
    let hasLoiOrLoaOrAgreementInConnection = false;
    if (activeConnection) {
      if (role === "generator") {
        hasLoiOrLoaOrAgreementInConnection = !!(
          activeConnection.genLoiDocId ||
          activeConnection.genLoaDocId ||
          activeConnection.genAgreementDocId
        );
      } else {
        hasLoiOrLoaOrAgreementInConnection = !!(
          activeConnection.conLoiDocId ||
          activeConnection.conLoaDocId ||
          activeConnection.conAgreementDocId
        );
      }
    }
    return (
      selectedFiles.loi !== null ||
      selectedFiles.loa !== null ||
      selectedFiles.fa !== null ||
      selectedFiles.other !== null ||
      hasNewLoiOrLoaUpload ||
      hasLoiOrLoaOrAgreementInConnection
    );
  }, [selectedFiles, hasNewLoiOrLoaUpload, activeConnection, role]);

  useEffect(() => {
    if (
      selectedFiles.other &&
      comments.trim() &&
      !uploadConfirmOpen &&
      !pendingUploadData
    ) {
      setPendingUploadData({ type: "other", displayName: "Other Documents" });
      setUploadConfirmOpen(true);
    }
  }, [selectedFiles.other, comments, uploadConfirmOpen, pendingUploadData]);

  const filteredDocuments = React.useMemo(() => {
    if (!documentViewHistory || !Array.isArray(documentViewHistory)) return [];
    return documentViewHistory;
  }, [documentViewHistory]);

  const hasLoiOrLoaInConnection = React.useMemo(() => {
    if (!activeConnection) return false;
    if (role === "generator") {
      return !!(activeConnection.genLoiDocId || activeConnection.genLoaDocId);
    }
    // Default to consumer
    return !!(activeConnection.conLoiDocId || activeConnection.conLoaDocId);
  }, [activeConnection, role]);

  const hasCurrentLoiOrLoa =
    hasNewLoiOrLoaUpload ||
    selectedFiles.loi ||
    selectedFiles.loa ||
    hasLoiOrLoaInConnection;

  const handleSubmitWithOwnershipCheck = async () => {
    if (uploading) return;

    if (!connectionId) {
      toast.error("Connection ID is missing.");
      return;
    }

    if (!hasCurrentLoiOrLoa) {
      toast.warn("Please upload atleast one document before submitting.");
      return;
    }

    try {
      const res = await submitDocuments(connectionId);
      if (res?.data?.code === 200) {
        dispatch(fetchViewDocumentHistory(connectionId));
        dispatch(fetchActiveLedger({ capId: listingId }));
        dispatch(fetchActiveConnection({ curr: 0, capId: listingId }));
        dispatch(fetchMainScreenActiveConnection({ capId: listingId }));
        handleClose();
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.message ||
          "Failed to sync Final Agreement. Please try again.",
      );
    }
  };

  const handleClosePreview = () => {
    setPreviewModal(false);
    setPreviewFileUrl(null);
  };

  const resetAllStates = () => {
    // setSelectedFiles({ loi: "", loa: "", fa: "", other: "" });
    // setUploadedDocumentIds({ loi: null, loa: null, fa: null, other: null });
    setComments("");
    setHasNewLoiOrLoaUpload(false);
  };

  // Effects
  useEffect(() => {
    if (connectionId) {
      dispatch(fetchViewDocumentHistory(connectionId));
    }
  }, [dispatch, connectionId]);

  // Render upload section component
  const UploadSection = ({
    title,
    generateHandler,
    showGenerate = true,
    fileInputId,
    fileName,
    placeholder,
    onView,
    onRemove,
    disabled,
    required = false,
    width,
  }) => {
    return (
      <div className={Styles.loiSection}>
        <span style={title === "Letter of Award" ? { paddingRight: "7%" } : {}}>
          {title} {required && <span style={{ color: "red" }}>*</span>}{" "}
          {showGenerate && (
            <span
              className={`${Styles.generateBtn} ${
                disabled ? Styles.disabledButton : ""
              }`}
              onClick={disabled ? undefined : generateHandler}
              style={{
                cursor: disabled ? "not-allowed" : "pointer",
                opacity: disabled ? 0.6 : 1,
              }}
            >
              Generate
            </span>
          )}
        </span>
        <span style={title === "Final Agreement" ? { paddingLeft: "5%" } : {}}>
          <label
            htmlFor={fileName ? undefined : fileInputId}
            className={`${Styles.customUploadBox} ${
              disabled ? Styles.disabledButton : ""
            }`}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              pointerEvents: disabled ? "none" : "auto",
              opacity: disabled ? 0.6 : 1,
              width: width ? width : "250px",
              maxWidth: "100%",
              minWidth: "0",
              cursor: "pointer",
            }}
            onClick={(e) => {
              if (disabled) return;
              if (fileName) {
                e.preventDefault();
                onView();
              }
            }}
          >
            <span
              aria-label={
                fileName
                  ? `View uploaded ${title} document`
                  : `Upload ${title} document`
              }
            >
              {fileName ? <ViewUploadFile /> : <UploadIcon />}
            </span>

            <span
              className={Styles.fileNameText}
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                flex: 1,
                minWidth: 0,
                maxWidth: "220px",
                display: "inline-block",
              }}
            >
              {fileName || placeholder}
            </span>
            {fileName && (
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  onRemove();
                }}
                style={{ cursor: "pointer" }}
                aria-label={`Remove uploaded ${title} document`}
                role="button"
                title="Remove"
              >
                <CrossIcon />
              </span>
            )}
          </label>

          <input
            type="file"
            id={fileInputId}
            name={fileInputId}
            accept=".pdf"
            className={Styles.hiddenFileInput}
            onChange={(e) => {
              handleFileChange(e);
            }}
            disabled={disabled}
          />
        </span>
      </div>
    );
  };

  return (
    <>
      <Ongoing
        open={ongoing}
        onClose={() => {
          setOngoing(false);
          handleClose();
          dispatch(fetchActiveConnection({ curr: 0, capId: listingId }));
        }}
      />

      <Modal open={open} onClose={handleClose}>
        <div
          className={`popupModal ${Styles.createEditModalCont} ${
            useSecondaryAccent ? "secondaryAccent" : ""
          }`}
        >
          <div
            className={`display_flex_row modalHeading ${Styles.headingText}`}
          >
            <div className={Styles.upHead}>Generate and Upload Docs</div>
            <Close
              style={{ fontSize: "24px", color: "#777777", cursor: "pointer" }}
              onClick={() => {
                resetAllStates();
                handleClose();
              }}
            />
          </div>

          <div className={Styles.uploadDocMain}>
            {/* Upload Files Section */}
            <div className={Styles.uploadFilesCont}>
              <UploadSection
                width={"200px"}
                title="Letter of Intent"
                generateHandler={documentGenerators.loi}
                fileInputId="fileUpload"
                fileName={selectedFiles.loi?.name || ""}
                placeholder="Upload Letter of Intent.pdf"
                onView={() => {
                  // Preview the selected file
                  if (selectedFiles.loi) {
                    const url = URL.createObjectURL(selectedFiles.loi);
                    setPreviewFileUrl(url);
                    setPreviewModal(true);
                  }
                }}
                onRemove={() => {
                  resetFileSelection("loi");
                }}
                // disabled={documentStates.isLoiDisabled}
              />
              <UploadSection
                width={"200px"}
                title="Letter of Award"
                generateHandler={documentGenerators.loa}
                fileInputId="fileUploadLoa"
                fileName={selectedFiles.loa?.name || ""}
                placeholder="Upload Letter of Award.pdf"
                onView={() => {
                  if (selectedFiles.loa) {
                    const url = URL.createObjectURL(selectedFiles.loa);
                    setPreviewFileUrl(url);
                    setPreviewModal(true);
                  }
                }}
                onRemove={() => {
                  resetFileSelection("loa");
                }}
                // disabled={documentStates.isLoaDisabled}
              />
              <UploadSection
                width={"200px"}
                title="Final Agreement"
                showGenerate={true}
                generateHandler={documentGenerators.fa}
                fileInputId="fileUploadFa"
                fileName={selectedFiles.fa?.name || ""}
                placeholder="Upload Final Agreement.pdf"
                onView={() => {
                  if (selectedFiles.fa) {
                    const url = URL.createObjectURL(selectedFiles.fa);
                    setPreviewFileUrl(url);
                    setPreviewModal(true);
                  }
                }}
                onRemove={() => {
                  resetFileSelection("fa");
                }}
                // disabled={documentStates.isFinalAgreementDisabled}
                required={false}
              />
              <UploadSection
                width={"200px"}
                title="Other Documents"
                generateHandler={() => {}}
                fileInputId="fileUploadOther"
                fileName={selectedFiles.other?.name || ""}
                placeholder="Upload Other Document.pdf"
                onView={() => {
                  if (selectedFiles.other) {
                    const url = URL.createObjectURL(selectedFiles.other);
                    setPreviewFileUrl(url);
                    setPreviewModal(true);
                  }
                }}
                onRemove={() => {
                  resetFileSelection("other");
                }}
                showGenerate={false}
                // disabled={documentStates.isOtherDocumentsDisabled}
              />
            </div>

            {/* Document History Section */}
            <div className={Styles.uploadFilesContDoc}>
              <div className={Styles.docHistoryCont}>
                <div className={Styles.uploadHistoryContainer}>
                  <span>Upload History</span>
                </div>

                {loading ? (
                  <div>Loading...</div>
                ) : error ? (
                  <div style={{ color: "red" }}>Failed to load history.</div>
                ) : Array.isArray(filteredDocuments) &&
                  filteredDocuments?.length > 0 ? (
                  <div className={`scroll_bar_y ${Styles.uploadTableContent}`}>
                    {filteredDocuments?.map((doc) => {
                      const datetime = doc.createdAt || "";
                      const [datePart, timeWithMs] = datetime.split("T") || [
                        "",
                        "",
                      ];
                      const timeWithSeconds = timeWithMs
                        ? timeWithMs.split(".")[0]
                        : "";
                      const timePart = timeWithSeconds
                        ? timeWithSeconds.substring(0, 5)
                        : "";

                      return (
                        <div key={doc.id} className={Styles.uploadTableHeader}>
                          <div className={Styles.uploadFileName}>
                            <span
                              style={{
                                width: "100%",
                                color: "var(--color-text-inactive)",
                              }}
                            >
                              {doc.entityName || "-"}
                            </span>
                            <span>
                              <strong>
                                {doc.documentType
                                  ? `${
                                      doc.documentType === "RANDOM"
                                        ? "OTHER"
                                        : doc.documentType
                                    } - `
                                  : ""}
                              </strong>
                              {doc.filename || "Untitled Document"}
                            </span>

                            <span
                              style={{
                                width: "100%",
                                color: "var(--color-text-inactive)",
                              }}
                            >
                              {doc.comment || ""}
                            </span>
                          </div>

                          <div className={Styles.uploadDateOther}>
                            <div>{formatDate(datePart)}</div>
                            <div>{timePart}</div>
                            <div
                              type="button"
                              onClick={() => handleViewDoc(doc.id)}
                              aria-label={`View document ${doc.filename}`}
                            >
                              <ViewIcon />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className={Styles.docViewSection}>
                    <div>No documents uploaded yet.</div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Approval Buttons */}
          {showApprovalButtons ? (
            <div className={Styles.uploadDocsButton}>
              <div
                className={Styles.approvalButtons}
                style={{
                  display: "flex",
                  gap: "10px",
                  justifyContent: "center",
                  paddingBottom: "10px",
                }}
              >
                <button
                  type="button"
                  className={Styles.rejectButton}
                  onClick={() => {
                    setConformReject(true);
                  }}
                  disabled={approvalLoading}
                >
                  Reject
                </button>
                <button
                  type="button"
                  className={`primary-button ${Styles.approveButton}`}
                  onClick={() => setConformOpen(true)}
                  disabled={approvalLoading}
                >
                  Proceed
                </button>
              </div>
            </div>
          ) : (
            <div className={` ${Styles.submitSec}`}>
              <div
                className={`primary-button ${Styles.approveButton}`}
                onClick={() => setSubmitConfirmOpen(true)}
                style={{
                  opacity: uploading ? 0.6 : 1,
                  pointerEvents: uploading ? "none" : "auto",
                }}
              >
                <span style={{ fontSize: "12px" }}> {"Submit"}</span>
              </div>
            </div>
          )}

          {/* Submit confirmation modal */}
          <ConfirmationModal
            secondaryHover={useSecondaryAccent}
            open={submitConfirmOpen}
            loading={uploading}
            handleClose={() => setSubmitConfirmOpen(false)}
            handleSubmit={async () => {
              setSubmitConfirmOpen(false);
              await handleSubmitWithOwnershipCheck();
            }}
            header={"Submit Documents"}
            data={
              `Your document will be submitted to the ${role === "consumer" ? "seller" : "buyer"} as the Final Agreement for their approval and execution. Do you want to proceed?`
            }
          />

          <ConfirmationModal
            secondaryHover={useSecondaryAccent}
            open={uploadConfirmOpen}
            loading={uploading}
            commentBox={pendingUploadData?.displayName === "Other Documents"}
            commentBoxHeading={"Comments"}
            handleCommentChange={handleCommentsChange}
            customStyle={{ minHeight: "160px" }}
            handleClose={handleCancelUpload}
            handleSubmit={performUpload}
            header={pendingUploadData?.displayName || "Document"}
            data={
              showApprovalButtons
                ? `Do you want to upload and share this document with the ${role === "consumer" ? "seller" : "buyer"}?`
                : pendingUploadData?.type === "fa"
                  ? `Do you want to submit the Final Agreement for approval by the ${role === "consumer" ? "seller" : "buyer"}?`
                  : `Do you want to upload ${pendingUploadData?.displayName || "this document"}?`
            }
            note={
              showApprovalButtons &&
              "If you’ve made any changes to the final document, please share it with the other party via chat for approval."
            }
          />

          <ConfirmationModal
            secondaryHover={useSecondaryAccent}
            open={conformOpen}
            loading={approvalLoading}
            handleClose={() => setConformOpen(false)}
            handleSubmit={() => {
              Approve();
            }}
            header={"Upload Docs Confirmation"}
            data={
              hasUploadedAnyDocument
                ? "Are you sure you want to approve the document(s)? Once approved, this listing will move to the ledger, and the connection will be finalized.\nPlease ensure that you have uploaded the countersigned document."
                : "You have not uploaded any document.Please upload at least one document to proceed."
            }
            customStyle={{ height: "240px" }}
            note={
              showApprovalButtons &&
              "If you’ve made any changes to the final document, please share it with the other party via chat for approval."
            }
          />
          <ConfirmationModal
            secondaryHover={useSecondaryAccent}
            open={conformReject}
            loading={approvalLoading}
            handleClose={() => setConformReject(false)}
            handleSubmit={() => {
              handleRejectClick();
            }}
            header={"Upload Docs Confirmation"}
            data={"Please confirm if you want to Reject the docs?"}
          />
        </div>
      </Modal>

      <PreviewModal
        open={previewModal}
        onClose={handleClosePreview}
        fileUrl={previewFileUrl}
      />
    </>
  );
};

export default UploadDocModal;
